import tableRelatedLanguagesMulti from './tableRelatedLanguagesMulti';

export default {
  title: 'Languages',
  attributeName: 'languagesMulti',
  getURL: 'languages/localesPaginated',
  blockRemoveWhenInField: {
    field: 'defaultLanguage',
    compareKey: 'locale',
    message: 'This value is set as default. To remove it, you must first change or remove it from the default language field.'
  },
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'locale',
  itemId: 'locale',
  tableConfig: tableRelatedLanguagesMulti,
};